module.exports = __webpack_public_path__ + "media/Images/icon-chart-purple-afee1ef3e065810f48190be273c681a9.svg";